import { useQuery } from "@tanstack/react-query";
import type { LayerWeightLimits, ScrapMixFilters } from "./models";
import { getScrapMixAnalysis } from "./repository";

export const useScrapMixAnalysis = (
  filters: ScrapMixFilters,
  layerWeightLimits: LayerWeightLimits,
  enabled: boolean,
) =>
  useQuery({
    queryKey: [
      "scrap-mix-analysis",
      filters.from.format("YYYY-MM-DD"),
      filters.to.format("YYYY-MM-DD"),
      filters.excludeOutOfRangeLayers,
      layerWeightLimits.min,
      layerWeightLimits.max,
      filters.shifts,
      filters.crews,
      filters.gradeIds,
      filters.recipeFamilyIds,
      filters.operatorIds,
      filters.chargeNumbers,
      filters.heatNames,
    ],
    queryFn: ({ signal }) =>
      getScrapMixAnalysis(filters, layerWeightLimits, signal),
    enabled,
    keepPreviousData: true,
    retry: false,
  });
